var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('woot-button',{staticClass:"toggle-sidebar",attrs:{"size":"small","variant":"clear","color-scheme":"secondary","icon":"list"},on:{"click":_vm.onMenuItemClick}})}
var staticRenderFns = []

export { render, staticRenderFns }